import styled, { css } from 'styled-components';
import { palette, ifProp } from 'styled-tools';
import { Label } from 'components';

interface CheckBoxDescProps {
    checked: boolean;
}

export const CheckBoxDesc = styled.div<CheckBoxDescProps>`
    position: relative;
    display: flex;
    align-items: center;
    height: 60px;
    width: 100%;
    border-radius: 8px;
    border: 1px solid ${ifProp('checked', palette('blue_900'), palette('gray_opacity_300'))};
    padding: 8px 20px;
    cursor: pointer;
    ${props => {
        if (props.checked) {
            return css`
                ${LabelDescription},
                ${LabelTitle} {
                    color: ${palette('blue_900')};
                }

                ${CheckBoxDescDimd}{
                    background-color: ${palette('blue_opacity_100')}
                }
            `;
        }
    }}
`;

export const IconWrapper = styled.div`
    margin-right: 12px;
`;

export const LabelWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const LabelTitle = styled(Label)`
    color: ${palette('gray_opacity_600')};
`;

export const LabelDescription = styled(Label)`
    color: ${palette('gray_opacity_400')};
`;

export const CheckBoxDescDimd = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: ${palette('transparent')};
`;